import { Outlet } from "react-router-dom";
import { registerStatsigExperiment } from "utils/tracking/mixpanel";
import { useExperimentValues } from "hooks/experiments/use-experiment-values";
import { WEB_CONFIRMATION_EXP, MOBILE_CONFIRMATION_EXP } from "settings";
import {
  Content,
  Logo,
  Main,
  Container,
  ContentFeature,
  LogoFeature,
  MainFeature,
  ContainerFeature,
} from "./styles";

export function ConfirmationLayout() {
  const webExpValues = useExperimentValues(WEB_CONFIRMATION_EXP, "control");
  const mobileExpValues = useExperimentValues(
    MOBILE_CONFIRMATION_EXP,
    "control",
  );
  const webExpGroupName = webExpValues?.groupName;
  const mobileExpGroupName = mobileExpValues?.groupName;
  const isWebExpControlGroup = webExpValues?.isControlGroup;
  const isMobileExpControlGroup = mobileExpValues?.isControlGroup;
  const isWebExpActive = webExpValues?.groupName;
  const isMobileExpActive = mobileExpValues?.groupName;

  isWebExpActive &&
    registerStatsigExperiment(WEB_CONFIRMATION_EXP, webExpGroupName as string);
  isMobileExpActive &&
    registerStatsigExperiment(
      MOBILE_CONFIRMATION_EXP,
      mobileExpGroupName as string,
    );

  return isWebExpControlGroup ||
    isMobileExpControlGroup ||
    (!isWebExpActive && !isMobileExpActive) ? (
    <Container>
      <Main>
        <Logo />
        <Content>
          <Outlet />
        </Content>
      </Main>
    </Container>
  ) : (
    <ContainerFeature>
      <MainFeature>
        <LogoFeature />
        <ContentFeature>
          <Outlet />
        </ContentFeature>
      </MainFeature>
    </ContainerFeature>
  );
}
